import React from "react";
// import "./StickyCTA.css"; // Migrating to Tailwind

const StickyCTA = ({ onClick, isVisible, top }) => {
  return (
    <div
      className={`fixed left-0 w-full bg-gradient-to-br from-primary to-primary-dark text-white p-4 text-center transition-transform duration-300 ease-in-out z-40 ${isVisible ? "translate-y-0" : "-translate-y-full"}`}
      onClick={onClick}
      style={{ top: top - 1 }}
    >
      <button className="bg-none border-none text-white text-base cursor-pointer p-0 m-0 w-full h-full">Begin Your Consultation</button>
    </div>
  );
};

export default StickyCTA;
